import { combineReducers } from 'redux';
import { GOTOWEBINAR_FETCH_FUTURE_WEBINARS, GOTOWEBINAR_FETCH_WEBINAR, GOTOWEBINAR_FETCH_ELIGIBLE_FORMS } from 'ContentData/actions/ActionTypes';
function eligibleForms(state = new Set(), action) {
  switch (action.type) {
    case GOTOWEBINAR_FETCH_ELIGIBLE_FORMS:
      {
        const {
          response
        } = action;
        if (!response) return state;
        /* IE11 does not support new Set(iterator) */
        return response.reduce((forms, guid) => {
          forms.add(guid);
          return forms;
        }, new Set());
      }
    default:
      return state;
  }
}
function webinars(state = {}, action) {
  switch (action.type) {
    case GOTOWEBINAR_FETCH_FUTURE_WEBINARS:
      {
        const {
          response,
          options
        } = action;
        if (!response) return state;
        const isFreshLoad = !(options !== null && options !== void 0 && options.cursor) || options.cursor.page === 0;
        const base = isFreshLoad ? {} : state;
        return response.results.reduce((acc, webinar) => {
          acc[webinar.webinarKey] = webinar;
          return acc;
        }, Object.assign({}, base));
      }
    case GOTOWEBINAR_FETCH_WEBINAR:
      {
        const {
          response
        } = action;
        if (!response) return state;
        return Object.assign({}, state, {
          [response.webinarKey]: response
        });
      }
    default:
      return state;
  }
}
export default combineReducers({
  eligibleForms,
  webinars
});